/**
 * Supabase service-role client for routine framework.
 * Service-role required because routines write across many tables.
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';
// FRIDGE-173: the untyped client let 43 routine queries reference tables and
// columns that do not exist (9 phantom columns measured), every one an
// unchecked string. The Database generic makes tsc the guard. Regenerate
// lib/database.types.ts from production after schema changes — see its header.
import type { Database } from '@/lib/database.types';

let _client: SupabaseClient<Database> | null = null;

export function opsSupabase(): SupabaseClient<Database> {
  if (_client) return _client;
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL || process.env.SUPABASE_URL;
  const key = process.env.SUPABASE_SERVICE_ROLE_KEY;
  if (!url || !key) {
    throw new Error(
      'Ops framework requires NEXT_PUBLIC_SUPABASE_URL + SUPABASE_SERVICE_ROLE_KEY'
    );
  }
  _client = createClient(url, key, {
    auth: { persistSession: false, autoRefreshToken: false },
  });
  return _client;
}
